/**
 * 싸우는 동안의 화면 배율(전장 1픽셀을 화면 몇 픽셀로 그리나). 그림을 모르는 셈만 둔다(시험이 본다).
 *
 * 처음부터 어디서나 2배였다 — 도트 그림이 화면 픽셀과 1:1로 맞아 가장 또렷한 값이라 골랐을 뿐 따로 잰 적이 없다. 폰
 * 세로에서 2배면 화면에 들어오는 전장 폭이 195px(전장의 7분의 1)이라, 적이 횡대(320px 남짓)로 오게 된 뒤로는 싸우는 동안
 * 내 본대의 가운데만 보였다. 플레이한 사람이 1 · 1.25 · 1.5 · 1.75 · 2배의 화면을 견줘 보고 골랐다: "1.5배로 하자."
 * 1.5배면 폰 세로에서 260px — 본대와 맞붙은 적이 함께 들어오고 병종이 그림으로 구분된다(1배는 사람이 25px쯤이라
 * 색으로만 읽혔다).
 *
 * **폰만 낮춘다.** 물음은 폰 세로 화면에서 나왔고, 넓은 화면(PC)은 2배에서도 전장이 넉넉히 보인다(1280px이면 640px).
 * 넓은 화면의 배율은 따로 정하지 않았다.
 */

/** 넓은 화면(PC)의 배율. 도트 그림 한 픽셀이 화면 한 픽셀이다. */
export const WIDE_ZOOM = 2;
/** 폰의 배율. */
export const PHONE_ZOOM = 1.5;
/**
 * 화면의 짧은 쪽이 이보다 작으면 폰으로 본다(CSS 픽셀). 폰을 눕혀도 짧은 쪽은 그대로라 세로·가로가 같은 배율이다 —
 * 돌릴 때 배율이 바뀌면 같은 판이 다른 크기로 보인다. 태블릿(짧은 쪽 768px~)과 PC는 넓은 화면이다.
 */
export const PHONE_SHORT_SIDE = 600;

/** 화면 크기(CSS 픽셀)에서 싸우는 동안의 배율. 크기를 모르면(0·NaN) 넓은 화면으로 친다. */
export function baseZoom(width: number, height: number): number {
  const short = Math.min(width, height);
  return short > 0 && short < PHONE_SHORT_SIDE ? PHONE_ZOOM : WIDE_ZOOM;
}
